/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import InsuranceTransactionsDataContent from "components/content/InsuranceTransactionDataContent";

import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * Insurance claims and electronic transactions page.
 * Manages insurance claim submissions and EDI transactions.
 * 
 * Features:
 * - Insurance claims tracking and status monitoring
 * - Electronic transaction (EDI) submission history
 * - Claim status updates (submitted, pending, paid, denied)
 * - ERA (Electronic Remittance Advice) processing
 * - Transaction filtering by payer, date, status
 * - Integration with billing encounters
 * - Remittance posting and payment reconciliation
 * - Claim rejection and denial management
 * 
 * @returns {JSX.Element} Insurance transactions page component
 */
const InsuranceTransactionsPage: React.FC = () => {
  return (
    <DefaultDashboardLayout>
      <InsuranceTransactionsDataContent />
    </DefaultDashboardLayout>
  );
};

export default InsuranceTransactionsPage;

